import React from 'react';
import {
  Platform,
  View,
  StyleSheet,
  Text,
  ScrollView,
} from 'react-native';
import { Button, UserDataConsumer, ShopGearBanner } from 'fitbeat.react-native-components';
import TrackingTargetedMuscleGroups from './components/tracking-targeted-muscle-groups-tile';
import TrackingWorkoutStandardStats from './components/tracking-workout-standard-tile-text';
import { TrackingTotalWorkoutTile } from './components/tracking-total-workout-tile';
import { TrackingLoadingTile } from './components/tracking-loading-tile';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { getWorkoutStats, loadInitialStateForWorkoutStats, shopForFitbeatGearSelected } from './actions';
import { UserServiceClient } from 'fitbeat.api-clients';
import { getApiConfig } from '../config';
import { AuthTokenBuilder } from '../utils/authTokenBuilder';
import { GoogleAnalytics } from '../services/google-analytics';
import { Field, reduxForm } from 'redux-form';
import { Dropdown } from '../ui';
import { toggleHeartRateMonitorModalVisible } from '../ui/redux';
import TrackingGaugeLegend from './components/tracking-gauge-legend';
import Theme from '../theme';
import { defaultScale } from '../utils/scaling';
import { trackingWorkoutStatsSelector } from './selectors';
const isWeb = Platform.OS === 'web';

class TrackingWorkoutStatsTile extends React.Component {

  constructor(props) {
    super(props);
    this.props.loadInitialStateForWorkoutStats();
  }

  componentDidMount = async () => {
    this.willFocusListener = this.props.navigation.addListener('didFocus', async () => {
      this.props.loadInitialStateForWorkoutStats();
    });
  }
  componentWillUnmount = () => {
    this.willFocusListener.remove();
  }

  openHRMonitorModel = () => {
    const { toggleModal } = this.props;
    toggleModal(true);
  }

  render() {
    const { user: { userProfile }, t } = this.props;
    const isError = this.props.workoutStats && this.props.workoutStats.find((stat) => stat.error === 'Requires Fitillion Heartrate Monitor.');
    return (
      <View style={style.mainContainer}>
        <View style={style.paddingContainer}>
          <ScrollView >
            {this.props.monthAndYearRange &&
              <View style={style.dropdownContainer}>
                <Field
                  webAbsolute
                  isRequired={false}
                  name='dateOfScan'
                  showLabel={false}
                  valueKey="value"
                  displayKey="displayName"
                  defaultIndex={0}
                  defaultValue={this.props.selectedMonthAndYear && this.props.selectedMonthAndYear.value}
                  options={this.props.monthAndYearRange && this.props.monthAndYearRange}
                  component={Dropdown}
                  rowWidth='90%'
                  onSelect={this.props.getWorkoutStats}
                  hideIndicatorSeparator={true}
                  mainDropdownContainerStyle={{ borderRadius: 0 }}
                  controlStyle={{backgroundColor: Theme.WHITE}}
                />
              </View>}
            <View style={style.mealTitleContainer}>
              <Text style={style.mealTitle}>{t('workoutStats')} {this.props.workoutHeaderDateRange && `${this.props.workoutHeaderDateRange.toUpperCase()}`}</Text>
            </View>
            {isError &&
              <View style={style.buttonContainer}>
                <Button
                  onPress={this.openHRMonitorModel}
                  isLoading={false}
                  fontColor={Theme.WHITE}
                  title={t('hrMonitorSetup')}
                  style={{ borderRadius: defaultScale(10) }}
                />
              </View>
            }
            {this.props.data && this.props.data.totals &&
              <TrackingTotalWorkoutTile totals={this.props.data.totals} />}
            {this.props.data && this.props.data.muscleGroupPercentages &&
              <TrackingTargetedMuscleGroups muscleGroupPercentages={this.props.data.muscleGroupPercentages} userProfile={userProfile} />
            }
            {this.props.isLoading === true ?
              <TrackingLoadingTile isLoading={this.props.isLoading} /> :
              this.props.workoutStats ?
                <TrackingWorkoutStandardStats standardStats={this.props.workoutStats} type={'workoutStats'} />
                :
                <View style={style.noDataContainer}>
                  <Text style={style.noDataText}>You haven’t completed any workouts this month</Text>
                </View>
            }
          </ScrollView>
        </View>
        { !this.props.isLoading && !isWeb && this.props.data.totals.total > 0 &&
            <TrackingGaugeLegend />
        }
      </View>
    )
  }
}

const style = StyleSheet.create({
  mainContainer: {
    backgroundColor: Theme.GREY_LIGHT,
    height: '100%',
  },
  paddingContainer: {
    paddingLeft: defaultScale(10),
    paddingRight: defaultScale(10),
    zIndex: 1000,
    flex: 1,
  },
  buttonContainer: {
    width: '100%',
    paddingBottom: defaultScale(10),
    paddingTop: defaultScale(10)
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    borderRadius: defaultScale(8),
    borderColor: '#575656',
    borderWidth: defaultScale(1),
    ...Platform.select({
      web: {
        paddingVertical: 0,
      },
    }),
  },
  mealTitleContainer: {
    padding: defaultScale(8),
    flexDirection: 'column',
    width: '100%',
  },
  mealOfDay: {
    ...Theme.textStyle.heading,
    color: Theme.WHITE,
  },
  mealTitle: {
    ...Theme.textStyle.bodyCopyBold,
    color: Theme.GREY_DARK,
    paddingLeft: defaultScale(4),
  },
  mealDetailsContainer: {
    flexDirection: 'row',
    width: '100%',
  },
  noDataContainer: {
    padding: defaultScale(20),
    alignItems: 'center',
  },
  noDataText: {
    ...Theme.graphStyle.customMedium14,
    color: '#B8B8B8',
    fontWeight: '300',
    letterSpacing: 0,
    lineHeight: defaultScale(20),
    marginTop: defaultScale(10),
    marginBottom: defaultScale(10),
  },
  dropdownContainer: {
    marginTop: defaultScale(10),
    zIndex: 1,
  },
});

const mapStateToProps = (state) => {
  const { isLoading, error, workoutHeaderDateRange, monthAndYearRange, selectedMonthAndYear } = state.tracking.view;
  const { stats } = state.tracking.data;
  return {
    error,
    isLoading,
    workoutHeaderDateRange,
    data: stats,
    workoutStats: trackingWorkoutStatsSelector(state),
    monthAndYearRange,
    selectedMonthAndYear,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const userServiceClient = new UserServiceClient(getApiConfig(), fetch, console.log, new AuthTokenBuilder(), GoogleAnalytics);
  return {
    loadInitialStateForWorkoutStats: () => dispatch(loadInitialStateForWorkoutStats(userServiceClient, new Date())),
    getWorkoutStats: (date) => {
      dispatch(getWorkoutStats(userServiceClient, new Date(), date));
    },
    toggleModal: (visible: boolean) => dispatch(toggleHeartRateMonitorModalVisible(visible)),
    shopForFitbeatGearSelected:() => dispatch(shopForFitbeatGearSelected()),
  }
}

TrackingWorkoutStatsTile = UserDataConsumer(connect(mapStateToProps, mapDispatchToProps)(TrackingWorkoutStatsTile));
TrackingWorkoutStatsTile = reduxForm({ form: 'WorkoutStatsForm' })(TrackingWorkoutStatsTile);
export default translate(['workoutHistory'], { wait: true })(TrackingWorkoutStatsTile);